import { watch, type Ref } from 'vue'
import type { RouteLocationNormalizedLoaded } from 'vue-router'

/** Kept players follow deep links on every visit, before walk claims run. */
export function usePlayerWalkScreen(route: RouteLocationNormalizedLoaded, settings: Ref<boolean>, library: Ref<boolean>, explorer: Ref<boolean>) {
  watch(() => route.fullPath, () => {
    const screen = route.name === 'player' ? route.query.screen : null
    settings.value = screen === 'settings'
    library.value = ['library', 'browse', 'belt-browser'].includes(String(screen))
    explorer.value = screen === 'explorer'
  }, { immediate: true, flush: 'sync' })
}
